import React from "react";

function Companions() {
  return (
    <>
      <section className="featured_icon featured_icon_box2 ps-3 pe-3">
        <div className="row     align-items-center">
          <div className="col-md-3 featured_icon_box">
            <img src="/assets/img/f7.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          <div className="col-md-3 featured_icon_box">
            <img src="/assets/img/f8.png" alt="logo" className="img-fluid"data-aos="fade-up" />
          </div>
          <div className="col-md-6 ps-0 pe-0">
            <h2 className="hadding hadding_bg text-center mb-0" data-aos="fade-up">
              Scotty V2 Companions
            </h2>
          </div>
        </div>
      </section>
      <section className="featured_icon featured_icon_box2 featured_icon_box3 ps-3 pe-3">
        <div className="row     align-items-center">
          <div className="col-md-4 featured_icon_box">
            <img
              src="/assets/img/jupiter-logo.png"
              alt="logo"
              className="img-fluid"
              data-aos="fade-up"
            />
          </div>
          <div className="col-md-4 featured_icon_box">
            <img src="/assets/img/f10.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          <div className="col-md-4 featured_icon_box">
            <img
              src="/assets/img/solana-logo.png"
              alt="logo"
              className="img-fluid solana-logo-icon"
              data-aos="fade-up"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Companions;
